import React, { forwardRef } from 'react';
import { Input } from 'ab-uitools-legacy'

interface MaskedInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  onBlur?: () => void;
  masked?: boolean;
}

const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ value, onChange, name, onBlur, masked, ...rest }, ref) => {
    const maskedValue =
      value?.length <= 3 ? value : value?.slice(0, 3) + '*'.repeat(value?.length - 3);

    const newValue = masked ? maskedValue : value;

    const handleMaskedChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newChar = e.target.value;

      if (newChar.length < value.length) {
        onChange({
          ...e,
          target: {
            ...e.target,
            name,
            value: value.slice(0, newChar.length),
          },
        });
      } else {
        const added = newChar[newChar.length - 1];
        onChange({
          ...e,
          target: {
            ...e.target,
            name,
            value: value + added,
          },
        });
      }
    };

    return (
      <>
        <input
          type="hidden"
          name={name}
          value={value}
          ref={ref}
        />
        <Input
          {...rest}
          currentValue={newValue}
          //eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          onChange={handleMaskedChange}
          onBlur={onBlur}
        />
      </>
    );
  }
);

export default MaskedInput;
